import React from "react"
import { useSelector } from "react-redux"
import { FiChevronUp, FiChevronDown } from "react-icons/fi"
import useT from "utils/hooks/useT"

export default function ScheduleMemberElement({ member, onEdit, extended, setExtended }) {
  const { t } = useT("common")
  const currentMemberId = useSelector((state) => state.auth.memberId)
  const isMember = useSelector((state) => state.auth.isMember)
  const isViewOnly = useSelector((state) => state.auth.isViewOnly)

  const editable = !isViewOnly && (!isMember || currentMemberId === member.id)

  return (
    <div
      className={"ScheduleMemberElement" + (editable ? " ScheduleMemberElement-editable" : "")}
      onClick={editable ? () => onEdit(member) : undefined}
      title={editable ? t("editMember") : undefined}
    >
      <h4>{member.initials}</h4>
      {member.archived && <h5>({t("archived")})</h5>}
      {extended ? (
        <FiChevronUp
          title={t("reduce")}
          onClick={(e) => {
            setExtended(false)
            e.stopPropagation()
          }}
        />
      ) : (
        <FiChevronDown
          title={t("expand")}
          onClick={(e) => {
            setExtended(true)
            e.stopPropagation()
          }}
        />
      )}
    </div>
  )
}
